const cacheKey = "vgcache";
// const timeToStale = 172800; // 2 days

export const fetch = (slug) => {
  return false;

  // const cache = loadCache()
  // const now = new Date().getTime()/1000

  // if(!cache) return false

  // let match = cache.find(c => {
  // 	return c.slug == slug
  // })

  // if(match) {

  // 	// check it's not stale

  // 	const timeSince = now - match.time

  // 	if(timeSince > timeToStale) {
  // 		return false
  // 	} else {
  // 		return match
  // 	}

  // }
};

export const save = (key, value) => {
  //return true

  let cache = loadCache();
  const now = new Date().getTime() / 1000;

  if (!cache) {
    cache = [];
  }

  cache.push({
    slug: key,
    response: value,
    time: now,
  });

  saveCache(cache);
};

const loadCache = () => {
  return JSON.parse(sessionStorage.getItem(cacheKey));
  //return JSON.parse(localStorage.getItem(cacheKey))
};

const saveCache = (cache) => {
  sessionStorage.setItem(cacheKey, JSON.stringify(cache));
  //return localStorage.setItem(cacheKey, JSON.stringify(cache));
};



// WEBPACK FOOTER //
// ./src/js/utils/Cache.js